import { t } from '@lingui/core/macro';

export default function boardDurationValidator(duration?: number) {
  if (!duration) {
    return t`Длительность не может быть пустым`;
  }
  if (duration <= 0) {
    return t`Длительность не может быть меньше или равна 0`;
  }
  return undefined;
}
